import { spacing } from '@hubble/tokens/web';
import 'react';
import { Flex } from '../../Flex/index.js';
import { jsx } from '@emotion/react/jsx-runtime';

const Footer = ({
  align = 'end',
  children
}) => {
  return jsx(Flex, {
    justifyContent: align,
    padding: spacing[24],
    gap: spacing[16],
    "data-footer": true,
    children: children
  });
};

export { Footer };
